export const KEYS = {
  CURRENT: "current",
  PAST: "past",
  FUTURE: "future",
  LOADING: "loading",
};
